export default "__VITE_ASSET__CVQkQO64__"